import React from 'react';
import bn from "../utils/bemnames";
import { _t } from "../utils/translations";
import {useGlobalState} from "../contexts/GlobalState";
import {IWidgetBuilderComponentMeta, widgetBuilderComponentMetaTypes, IEvent} from '../utils/types';
import {fetchNextEventTimeFromStages} from '../api/league-center';
import {generateCdnAssetsUrl} from '../utils/helpers';

const bem = bn.create('league-countdown');

interface IProps {
    metas: IWidgetBuilderComponentMeta[]
}

interface ITimeDiff {
    remDays: String | null,
    remHours: String | null,
    remMinutes: String | null,
    remSeconds: String | null
}

interface IMetaItems {
    title: String| null,
    link: string | null,
    linkText: String | null
}

const LeagueCountdown: React.FC<IProps> = ({
    metas
}) => {
    const [loading, setLoading] = React.useState<Boolean>(false);
    const [event, setEvent] = React.useState<IEvent>();
    const [timeDiff, setTimeDiff] = React.useState<ITimeDiff>({
        remDays: "--",
        remHours: "--",
        remMinutes: "--",
        remSeconds: "--"
    });
    const [metaItems] = React.useState<IMetaItems>({
        title: null,
        link: null,
        linkText: null
    })
    const {globalState} = useGlobalState();

    const zeroPad = (num: number) => String(num).padStart(2, '0')

    const trimTimeKeys = (key:string, value:string) => {
        let string = key.replace('rem', '');
        if(value === "01"){
            string = string.slice(0, -1)
        }
        return string;
    }

    //On Mount
    React.useEffect(() => { 
        const getEventTime = async () => {
            setLoading(true);
            let stageObjects = globalState.widget?.tournaments[0].data[0].stages;
            if(!stageObjects) return;
    
            let stageIds:number[] = [];
            stageObjects.forEach((stage) => {
                stageIds.push(stage.id)
            })
            
            const payload = {
                stageIds: stageIds
            }
    
            try {
                const r = await fetchNextEventTimeFromStages(payload);
                if (r) {
                    await setEvent(r)
                }
            } catch (err) {
              console.error(err);
            } 
        }

        getEventTime();
        
        metas.forEach((metaItem) => {
            switch(metaItem.type){
                case widgetBuilderComponentMetaTypes.leagueCenterCountdownTitle:
                    metaItems.title = metaItem.value;
                    break;
                case widgetBuilderComponentMetaTypes.leagueCenterCountdownLinkText:
                    metaItems.linkText = metaItem.value;
                    break;
                case widgetBuilderComponentMetaTypes.leagueCenterCountdownLink:
                    metaItems.link = metaItem.value;
                    break;
            }
        })
    }, [globalState.widget?.tournaments, metaItems, metas])

    //Once event is set
    React.useEffect(() => {
        const initCountdown = (r: IEvent | undefined) => {
            if (r === undefined) return;
    
            const now = new Date();
            const eventTime = new Date(r.startTime);
    
            let diff = eventTime.getTime() - now.getTime();
    
            let totalDays = Math.floor(diff / (1000 * 3600 * 24));
            diff = diff - (totalDays * (1000 * 3600 * 24));
    
            let totalHours = Math.floor(diff / (1000 * 3600));
            diff = diff - (totalHours * (1000 * 3600));
    
            let totalMinutes = Math.floor(diff / (1000 * 60));
            diff = diff - (totalMinutes * (1000 * 60));
    
            let totalSeconds = Math.floor(diff / 1000);
    
            setTimeDiff({
                remDays: zeroPad(totalDays),
                remHours: zeroPad(totalHours),
                remMinutes: zeroPad(totalMinutes),
                remSeconds: zeroPad(totalSeconds),
            });
        }

        if (event === undefined) return;
        if (event.startTime) {
            
            setInterval(function () {
                initCountdown(event);
            }, 1000)
        }
    }, [event]);

    return(
        <div className={bem.e("container")} style={{backgroundImage: `url(${generateCdnAssetsUrl('stadiums/qatar.jpeg')})`}}>
            {loading && <div className={bem.e("box")}>
                <div className={bem.e("box-title-container")}>
                    <div className={bem.e("box-title-text")}>
                        {metaItems.title}
                    </div>
                </div>

                <div className={bem.e("clock-cells")}>
                    {Object.entries(timeDiff).map((item, i) => {
                        return(
                            <div key={`clock-cells-${i}`} className={bem.e("clock-cells-item")}>
                                <div className={ `${bem.e("clock-cells-item-num")} ${item[0] === 'remDays' ? bem.e('clock-cells-item-num__bold') : ''}` }>
                                    <>{item[1]}</>
                                </div> 
                                <div className={bem.e("clock-cells-item-text")}>
                                    <>{_t(trimTimeKeys(item[0], item[1]))}</>
                                </div> 
                            </div>
                        )      
                    })}
                </div>

                <a href={metaItems.link!} target='_blank' rel="noreferrer" className={bem.e("box-link-container")}>
                    <div className={bem.e("box-title-text")}>
                        {metaItems.linkText}
                    </div>
                </a>
            </div>
            }
            
        </div>
    )
}

export default LeagueCountdown;